import { getCameraBimDetails } from '@api/services/camera.service';
import { useQuery } from '@tanstack/react-query';
import { generateProxyUrl } from '@utils/common';
import axios from 'axios';
// import { getCameraBimDetails } from 'api/services';

const useCameraBimData = (clientId: string, projectId: string, cameraId: string, isBimEnabled?: boolean) => {
    const bimQuery = useQuery(
        ['cameraBim', projectId, cameraId],
        () => getCameraBimDetails(clientId, projectId, cameraId)
        // {
        //     enabled: Boolean(isBimEnabled),
        // }
    );
    const schedulingFileQuery = useQuery({
        queryKey: ['schedulingFileQuery', projectId, cameraId],
        queryFn: async () => {
            const { data } = await axios.get(generateProxyUrl(bimQuery.data?.schedulingFileUrl));
            console.log('data in scheduling', data);
            return data;
        },
        enabled: Boolean(bimQuery.data?.schedulingFileUrl),
        retry: 0,
    });

    return {
        isLoading: bimQuery.isLoading,
        details: bimQuery.data,
        error: bimQuery.error,
        schedulingDetails: schedulingFileQuery.data || null,
    };
};

export default useCameraBimData;
